import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface DeviceTypeProps {
  open: boolean;
  handleClose: () => void;
}

function CreateDeviceTypeModal({
  open,
  handleClose
}: DeviceTypeProps) {

  const token = useSelector(setUserToken)
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const [isValid, setIsValid] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [deviceTypeName, setdeviceTypeName] = useState("") as any;
  const [adwordValue, setAdwordValue] = useState('') as any;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const CreateNewDeviceType = async() => {
    const data = {
      device_type_name: deviceTypeName,
      adwords_value: adwordValue,
    };
    try{
      setIsLoading(true);
      setLoading(true);
      if (oauthTokenHeader) {
        await MetaEntitiesEndPointLogic.createMetadeviceType(oauthTokenHeader, data);
      } else {
        throw new Error("User doesn't have permissions to create new themes");
      }
      if(oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaDeviceType(oauthTokenHeader,dispatch);
      }
    } catch (error) {
      console.error(error, "error");
    } finally{
      handleClose();
      setLoading(false);
      setIsLoading(false);
      setdeviceTypeName(null);
      setAdwordValue(null);
      await MetaEntitiesEndPointLogic.getMetaDeviceType(oauthTokenHeader,dispatch);
    }
  };

  const validate = async () => {
    if (!deviceTypeName || !adwordValue) {
      setSnackbarOpen(true);
      setSnackbarMessage('All fields are mandatory.');
      setIsValid(false);
      return false;
    }
    if (adwordValue && adwordValue.length > 5) {
      setSnackbarOpen(true);
      setSnackbarMessage('Adword value must not be greater than 5 characters.');
      setIsValid(false);
      return false;
    }
    setIsValid(true);
    return true;
  };
  
  const handleCreateDeviceType = async () => {
    const isFormValid = await validate();
    if (!isFormValid) return;
    try {
      setLoading(true);
      await CreateNewDeviceType();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    handleClose();
    setdeviceTypeName(null);
    setAdwordValue(null);
  }

  const renderSnackbar = () => {
    return (
      <Snackbar
        sx={{ zIndex: "9999999" }}
        open={snackbarOpen}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          elevation={1}
          variant="filled"
          onClose={() => setSnackbarOpen(false)}
          severity={isValid ? "success" : "error"}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    );
    };

  return (
    <>
      {loading ? (<SimpleBackdrop />) : (
        <>
          {renderSnackbar()}
          <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
          >
            <Paper sx={{ padding: "16px 24px 20px 24px" }}>
              <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
                Create New DeviceType
              </DialogTitle>
              <Typography sx={{ mb: 1 }}>Details</Typography>
              <Grid container mt={0} columnSpacing={3}>
                <Grid item xs={6}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Device Type *" // Set your label here
                    value={deviceTypeName}
                    onChange={(e: any) => setdeviceTypeName(e.target.value)}
                    placeholder="Enter unique Device Type Name" // Set your placeholder here
                    color="secondary"
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Adwords Value *" // Set your label here
                    value={adwordValue}
                    onChange={(e: any) => setAdwordValue(e.target.value)}
                    placeholder="Enter unique Adwords Value" // Set your placeholder here
                    color="secondary"
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Typography
                sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
              >
                All fields are mandatory.
              </Typography>

              <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
                <Button color="secondary" onClick={handleCancel} sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button variant="contained" color="secondary" disabled={!deviceTypeName || !adwordValue}
                  data-tracker="237"
                  onClick={handleCreateDeviceType}>
                  Create <DoneIcon sx={{ ml: 1 }} />
                </Button>
              </Stack>
            </Paper>
          </Dialog>
        </>

      )}
    </>
  );
}

export default CreateDeviceTypeModal;
